import DriverAddRequest from "../../api/raily/driver/add/driver-add.request";
import DriverDetailsRequest from "../../api/raily/driver/details/driver-details.request";
import driverApiService from "../../api/raily/driver/driver-api.service";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import HttpError from "../../utils/http/http.error";
import DriverAddError from "./add/driver-add-error";
import DriverAddParams from "./add/driver-add-params";
import driverAddParamsFactory from "./add/driver-add-params.factory";
import DriverDetails from "./details/driver-details";
import DriverDetailsParams from "./details/driver-details-params";
import driverDetailsParamsFactory from "./details/driver-details-params.factory";
import driverDetailsFactory from "./details/driver-details.factory";
import UserDriverListError from "../user/driver/list/user-driver-list-error";
import DriverContractsListError from "./contracts/list/driver-contracts-list-error";
import DriverContractsListRequest from "../../api/raily/driver/contracts/list/driver-contracts-list.request";
import DriverContractsList from "./contracts/list/driver-contracts-list";
import DriverContractsListParams from "./contracts/list/driver-contracts-list-params";
import driverContractsListFactory from "./contracts/list/driver-contracts-list.factory";
import driverContractsListParamsFactory from "./contracts/list/driver-contracts-list-params.factory";
import DriverContractsDriversListRequest from "../../api/raily/driver/contracts/drivers-list/driver-contracts-drivers-list.request";
import DriverContractsDriversList from "./contracts/drivers-list/driver-contracts-drivers-list";
import DriverContractsDriversListError from "./contracts/drivers-list/driver-contracts-drivers-list-error";
import DriverContractsDriversListParams from "./contracts/drivers-list/driver-contracts-drivers-list-params";
import driverContractsDriversListParamsFactory from "./contracts/drivers-list/driver-contracts-drivers-list-params.factory";
import driverContractsDriversListFactory from "./contracts/drivers-list/driver-contracts-drivers-list.factory";
import DriverTaxiDriverAssociationsError from "./taxi-driver/associations/driver-taxi-driver-associations-error";
import DriverTaxiDriverAssociationsParams from "./taxi-driver/associations/driver-taxi-driver-associations-params";
import DriverTaxiDriverAssociations from "./taxi-driver/associations/driver-taxi-driver-associations";
import DriverTaxiDriverAssociationsRequest from "../../api/raily/driver/taxi-driver/associations/driver-taxi-driver-associations.request";
import driverTaxiDriverAssociationsParamsFactory from "./taxi-driver/associations/driver-taxi-driver-associations-params.factory";
import driverTaxiDriverAssociationsFactory from "./taxi-driver/associations/driver-taxi-driver-associations.factory";
import DriverPlanListRequest from "../../api/raily/driver/plan/list/driver-plan-list.request";
import DriverCandidatureActiveRequest from "../../api/raily/driver/candidature/active/driver-candidature-active.request";
import DriverCandidatureActiveError from "./candidature/active/driver-candidature-active-error";
import DriverCandidatureActiveParams from "./candidature/active/driver-candidature-active-params";
import driverCandidatureActiveParamsFactory from "./candidature/active/driver-candidature-active-params.factory";
import driverCandidatureActiveErrorFactory from "./candidature/active/driver-candidature-active-error.factory";
import DriverPotentialPlanRequest from "../../api/raily/driver/potential-plan/driver-potential-plan.request";
import DriverPotentialPlan from "./potential-plan/driver-potential-plan";
import DriverPotentialPlanError from "./potential-plan/driver-potential-plan-error";
import DriverPotentialPlanParams from "./potential-plan/driver-potential-plan-params";
import driverPotentialPlanParamsFactory from "./potential-plan/driver-potential-plan-params.factory";
import driverPotentialPlanFactory from "./potential-plan/driver-potential-plan.factory";
import DriverPlanListError from "./plan/list/driver-plan-list-error";
import DriverPlanListParams from "./plan/list/driver-plan-list-params";
import DriverPlanList from "./plan/list/driver-plan-list";
import driverPlanListParamsFactory from "./plan/list/driver-plan-list-params.factory";
import driverPlanListFactory from "./plan/list/driver-plan-list.factory";
import DriverPlanAcceptRequest from "../../api/raily/driver/plan/accept/driver-plan-accept.request";
import DriverPlanAcceptError from "./plan/accept/driver-plan-accept-error";
import DriverPlanAcceptParams from "./plan/accept/driver-plan-accept-params";
import driverPlanAcceptParamsFactory from "./plan/accept/driver-plan-accept-params.factory";
import {
  DriverPlanAcceptErrorResponse,
  DriverPlanNotAcceptableResponseErrorType,
} from "../../api/raily/driver/plan/accept/driver-plan-accept.response";
import driverPlanAcceptErrorFactory from "./plan/accept/driver-plan-accept-error.factory";
import DriverCandidatureDeleteParams from "./candidature/delete/driver-candidature-delete-params";
import DriverCandidatureDeleteRequest from "../../api/raily/driver/candidature/delete/driver-candidature-delete.request";
import DriverCandidatureDeleteError from "./candidature/delete/driver-candidature-delete-error";
import driverCandidatureDeleteParamsFactory from "./candidature/delete/driver-candidature-delete-params.factory";
import DriverPlanEntryCheckoutEventAddRequest from "../../api/raily/driver/plan-entry/checkout-event/add/driver-plan-entry-checkout-event-add.request";
import {
  DriverPlanEntryCheckoutEventAddErrorResponse,
  DriverPlanEntryCheckoutEventAddErrorResponseErrorType,
} from "../../api/raily/driver/plan-entry/checkout-event/add/driver-plan-entry-checkout-event-add.response";
import DriverPlanEntryCheckoutEventDeleteRequest from "../../api/raily/driver/plan-entry/checkout-event/delete/driver-plan-entry-checkout-event-delete.request";
import DriverPlanEntryCheckoutEventUpdateRequest from "../../api/raily/driver/plan-entry/checkout-event/update/driver-plan-entry-checkout-event-update.request";
import DriverPlanEntryCheckoutEventAddError from "./plan-entry/checkout-event/add/driver-plan-entry-checkout-event-add-error";
import driverPlanEntryCheckoutEventAddErrorFactory from "./plan-entry/checkout-event/add/driver-plan-entry-checkout-event-add-error.factory";
import DriverPlanEntryCheckoutEventAddParams from "./plan-entry/checkout-event/add/driver-plan-entry-checkout-event-add-params";
import driverPlanEntryCheckoutEventAddParamsFactory from "./plan-entry/checkout-event/add/driver-plan-entry-checkout-event-add-params.factory";
import DriverPlanEntryCheckoutEventDeleteError from "./plan-entry/checkout-event/delete/driver-plan-entry-checkout-event-delete-error";
import DriverPlanEntryCheckoutEventDeleteParams from "./plan-entry/checkout-event/delete/driver-plan-entry-checkout-event-delete-params";
import driverPlanEntryCheckoutEventDeleteParamsFactory from "./plan-entry/checkout-event/delete/driver-plan-entry-checkout-event-delete-params.factory";
import DriverPlanEntryCheckoutEventUpdateError from "./plan-entry/checkout-event/update/driver-plan-entry-checkout-event-update-error";
import DriverPlanEntryCheckoutEventUpdateParams from "./plan-entry/checkout-event/update/driver-plan-entry-checkout-event-update-params";
import driverPlanEntryCheckoutEventUpdateParamsFactory from "./plan-entry/checkout-event/update/driver-plan-entry-checkout-event-update-params.factory";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";

const getDetails = async (
  params: DriverDetailsParams,
  abortSignal: AbortSignal,
): Promise<DriverDetails> => {
  const request: DriverDetailsRequest =
    driverDetailsParamsFactory.create(params);

  try {
    const response = await driverApiService().getDetails(request, abortSignal);

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const driverDetails = driverDetailsFactory.create(response.data);

    return driverDetails;
  } catch (_error) {
    const error = _error as HttpError | UserDriverListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const addDriver = async (
  params: DriverAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: DriverAddRequest = driverAddParamsFactory.create(params);

  try {
    const response = await driverApiService().addDriver(request, abortSignal);

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | DriverAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getDriverContractsList = async (
  params: DriverContractsListParams,
  abortSignal: AbortSignal,
): Promise<DriverContractsList> => {
  const request: DriverContractsListRequest =
    driverContractsListParamsFactory.create(params);

  try {
    const response = await driverApiService().getContractsList(
      request,
      abortSignal,
    );
    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
    const driverContractsList: DriverContractsList =
      driverContractsListFactory.create(response);

    return driverContractsList;
  } catch (_error) {
    const error = _error as HttpError | DriverContractsListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getDriverContractsDriversList = async (
  params: DriverContractsDriversListParams,
  abortSignal: AbortSignal,
): Promise<DriverContractsDriversList> => {
  const request: DriverContractsDriversListRequest =
    driverContractsDriversListParamsFactory.create(params);

  try {
    const response = await driverApiService().getContractsDriversList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const driverContractsDriversList: DriverContractsDriversList =
      driverContractsDriversListFactory.create(response);

    return driverContractsDriversList;
  } catch (_error) {
    const error = _error as HttpError | DriverContractsDriversListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getTaxiDriverAssociations = async (
  params: DriverTaxiDriverAssociationsParams,
  abortSignal: AbortSignal,
): Promise<DriverTaxiDriverAssociations> => {
  const request: DriverTaxiDriverAssociationsRequest =
    driverTaxiDriverAssociationsParamsFactory.create(params);

  try {
    const response = await driverApiService().getTaxiDriverAssociations(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const DriverTaxiDriverAssociations: DriverTaxiDriverAssociations =
      driverTaxiDriverAssociationsFactory.create(response);

    return DriverTaxiDriverAssociations;
  } catch (_error) {
    const error = _error as HttpError | DriverTaxiDriverAssociationsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getPlanList = async (
  params: DriverPlanListParams,
  abortSignal: AbortSignal,
): Promise<DriverPlanList> => {
  const request: DriverPlanListRequest =
    driverPlanListParamsFactory.create(params);

  try {
    const response = await driverApiService().getPlanList(request, abortSignal);

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const driverPlan: DriverPlanList = driverPlanListFactory.create(response);

    return driverPlan;
  } catch (_error) {
    const error = _error as HttpError | DriverPlanListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getActiveCandidature = async (
  params: DriverCandidatureActiveParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: DriverCandidatureActiveRequest =
    driverCandidatureActiveParamsFactory.create(params);

  try {
    const response = await driverApiService().getActiveCandidature(
      request,
      abortSignal,
    );

    if (response.status === 404) {
      throw driverCandidatureActiveErrorFactory.createNotActiveError();
    }

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | DriverCandidatureActiveError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getDriverRoutePlansAfterCandidatureApproval = async (
  params: DriverPotentialPlanParams,
  abortSignal: AbortSignal,
): Promise<DriverPotentialPlan> => {
  const request: DriverPotentialPlanRequest =
    driverPotentialPlanParamsFactory.create(params);

  try {
    const response =
      await driverApiService().getDriverRoutePlansAfterCandidatureApproval(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const driverPotentialPlan: DriverPotentialPlan =
      driverPotentialPlanFactory.create(response);

    return driverPotentialPlan;
  } catch (_error) {
    const error = _error as HttpError | DriverPotentialPlanError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const createAcceptPlanCandidatureError = (
  error: DriverPlanAcceptErrorResponse,
): any => {
  switch (error.data.errorType) {
    case DriverPlanNotAcceptableResponseErrorType.NO_TAXI_DRIVER_ASSOCIATION:
      return driverPlanAcceptErrorFactory.createNoTaxiDriverAssociationError();
    case DriverPlanNotAcceptableResponseErrorType.DELETE_SOLVED_ORDER_TARGET_NOT_FOUND:
      return driverPlanAcceptErrorFactory.createDeleteSolvedOrderTargetNotFoundError();
    case DriverPlanNotAcceptableResponseErrorType.TOO_MANY_CHECKOUT_EVENTS:
      return driverPlanAcceptErrorFactory.createTooManyCheckoutEventsError();
    case DriverPlanNotAcceptableResponseErrorType.NO_VALID_TAXI_DRIVER_CONTRACT:
      return driverPlanAcceptErrorFactory.createNoValidTaxiDriverContractError();
    case DriverPlanNotAcceptableResponseErrorType.NO_VALID_TAXI_RAILY_CONTRACT:
      return driverPlanAcceptErrorFactory.createNoValidTaxiRailyContractError();
    case DriverPlanNotAcceptableResponseErrorType.CANDIDATE_FITS_WITH_PLAN_ENTRY_COLLISION:
      return driverPlanAcceptErrorFactory.createPlanEntryCandidateCollision();
    case DriverPlanNotAcceptableResponseErrorType.CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME:
      return driverPlanAcceptErrorFactory.createCandidateFitsWithNotEnoughTime();
    case DriverPlanNotAcceptableResponseErrorType.PLAN_ENTRY_CANDIDATE_COLLISION:
      return driverPlanAcceptErrorFactory.createPlanEntryCandidateCollision();
    case DriverPlanNotAcceptableResponseErrorType.PLAN_ENTRY_CANDIDATE_START_TIME_EXPIRED_ERROR:
      return driverPlanAcceptErrorFactory.createPlanEntryCandidateStartTimeExpiredError();
    default:
      return driverPlanAcceptErrorFactory.createDefaultError(
        error.data.errorType,
      );
  }
};

const acceptPlanCandidature = async (
  params: DriverPlanAcceptParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: DriverPlanAcceptRequest =
    driverPlanAcceptParamsFactory.create(params);

  try {
    const response = await driverApiService().acceptPlanCandidature(
      request,
      abortSignal,
    );

    if (response.status === 406) {
      throw createAcceptPlanCandidatureError(
        response as DriverPlanAcceptErrorResponse,
      );
    }

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | DriverPlanAcceptError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const deletePlanCandidature = async (
  params: DriverCandidatureDeleteParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: DriverCandidatureDeleteRequest =
    driverCandidatureDeleteParamsFactory.create(params);

  try {
    const response = await driverApiService().deletePlanCandidature(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | DriverCandidatureDeleteError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const updateCheckoutEvent = async (
  params: DriverPlanEntryCheckoutEventUpdateParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: DriverPlanEntryCheckoutEventUpdateRequest =
    driverPlanEntryCheckoutEventUpdateParamsFactory.create(params);

  try {
    const response = await driverApiService().updateCheckoutEvent(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | DriverPlanEntryCheckoutEventUpdateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const deleteCheckoutEvent = async (
  params: DriverPlanEntryCheckoutEventDeleteParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: DriverPlanEntryCheckoutEventDeleteRequest =
    driverPlanEntryCheckoutEventDeleteParamsFactory.create(params);

  try {
    const response = await driverApiService().deleteCheckoutEvent(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | DriverPlanEntryCheckoutEventDeleteError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const createCheckoutEventAddErrorsFromNotAcceptableResponse = (
  response: DriverPlanEntryCheckoutEventAddErrorResponse,
): any => {
  switch (response.data.errorType) {
    case DriverPlanEntryCheckoutEventAddErrorResponseErrorType.DRIVER_HAS_CANDIDATURE:
      return driverPlanEntryCheckoutEventAddErrorFactory.createDriverHasCandidatureError();
    default:
      return driverPlanEntryCheckoutEventAddErrorFactory.createDefaultError();
  }
};

const addCheckoutEvent = async (
  params: DriverPlanEntryCheckoutEventAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: DriverPlanEntryCheckoutEventAddRequest =
    driverPlanEntryCheckoutEventAddParamsFactory.create(params);

  try {
    const response = await driverApiService().addCheckoutEvent(
      request,
      abortSignal,
    );

    if (response.status === 406) {
      throw createCheckoutEventAddErrorsFromNotAcceptableResponse(
        response as DriverPlanEntryCheckoutEventAddErrorResponse,
      );
    }

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | DriverPlanEntryCheckoutEventAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const driverService = {
  getDetails,
  addDriver,
  getDriverContractsList,
  getDriverContractsDriversList,
  getTaxiDriverAssociations,
  getPlanList,
  getActiveCandidature,
  getDriverRoutePlansAfterCandidatureApproval,
  acceptPlanCandidature,
  deletePlanCandidature,
  updateCheckoutEvent,
  deleteCheckoutEvent,
  addCheckoutEvent,
};

export default driverService;
